import { render } from "./CardSetDetail.vue?vue&type=template&id=8d0ced18&scoped=true&ts=true"
import script from "./CardSetDetail.vue?vue&type=script&lang=ts"
export * from "./CardSetDetail.vue?vue&type=script&lang=ts"

import "./CardSetDetail.vue?vue&type=style&index=0&id=8d0ced18&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d0ced18"]])

export default __exports__